import React, { ReactElement } from 'react';

interface IconWrapperProps {
    size?: number;
    color?: string;
    className?: string;
    onClick?: () => void;
    children?: ReactElement;
}

const Icon: React.FC<IconWrapperProps> = ({
    size = 24,
    color = 'black',
    className,
    onClick,
    children
}) => {
    const styles = {
        width: size,
        height: size,
        color: color,
        cursor: onClick ? 'pointer' : 'default'
    };

    return (
        <div style={styles} className={className} onClick={onClick}>
            {children}
        </div>
    );
};

export default Icon;
